import React from 'react';
import SliderPartialRequest from './SliderPartialRequest';
import Grid from '@material-ui/core/Grid';

/**
 * @typedef {import('./SliderPartialRequest').SliderPartialRequestProps} SliderPartialRequestWithLabelProps
 *
 */

export const sliderLabelProps = {
    backgroundColor: '#1a518a',
    color: '#FFF',
    textAlign: 'center',
    padding: '10px 0',
};

/**
 *
 * @param {SliderPartialRequestWithLabelProps} param0
 */
const SliderPartialRequestWithLabel = ({
    storeData = {},
    shifts,
    handleChange,
    selectedPartial,
    onSelectionInvalid,
    requestType,
    selectedPartialStartDate = null,
    selectedPartialEndDate = null,
    isReadOnly = false,
}) => {
    return (
        <Grid container>
            <Grid item xs={12} style={{ padding: '0 20px' }}>
                <SliderPartialRequest
                    shifts={shifts}
                    storeData={storeData}
                    requestType={requestType}
                    handleChange={handleChange}
                    onSelectionInvalid={onSelectionInvalid}
                    selectedPartialStartDate={selectedPartialStartDate}
                    selectedPartialEndDate={selectedPartialEndDate}
                    isReadOnly={isReadOnly}
                />
            </Grid>
            <Grid item xs={12} style={sliderLabelProps}>
                {selectedPartial}
            </Grid>
        </Grid>
    );
}

export default SliderPartialRequestWithLabel;
